export const adminbar = document.getElementById('wpadminbar');
export const root = document.documentElement;
export const body = document.body;
export const header = document.body.children.find('header');
export const banner = document.body.children.find('#banner');
export const main = document.body.children.find('main');
export const footer = document.body.children.find('footer');
